import { useEffect } from 'react'

/** A single, progressive entrance for selected compositions, never hidden content. */
export function useEditorialMotion(route: string) {
  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)')
    if (preference.matches || !('IntersectionObserver' in window)) return
    const targets = document.querySelectorAll<HTMLElement>('[data-editorial-reveal]')
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        entry.target.classList.add('editorial-arrived')
        observer.unobserve(entry.target)
      })
    }, { threshold: 0.12 })
    targets.forEach(target => observer.observe(target))
    const stop = () => {
      if (preference.matches) {
        observer.disconnect()
        targets.forEach(target => target.classList.remove('editorial-arrived'))
      }
    }
    preference.addEventListener('change', stop)
    return () => {
      observer.disconnect()
      preference.removeEventListener('change', stop)
      targets.forEach(target => target.classList.remove('editorial-arrived'))
    }
  }, [route])
}
